module.exports = __webpack_public_path__ + "cf9b83cefc74fed091016252aff86fe6.jpg";